<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-left text-sm-left mb-4 mb-sm-0">
        <h3 class="page-title">
          <template v-if="isEdit"> Edytuj status </template>
          <template v-else> Nowy status </template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end"
      >
        <d-button
          theme="primary"
          outline
          @click.prevent="$router.push('/admin/statuses')"
          class="mr-1"
        >
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button theme="success" @click.prevent="validateForm">
          <i class="material-icons">done</i>
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-card-body>
          <validation-observer
            v-if="allDataLoaded && !submitted"
            ref="status-form"
            tag="form"
          >
            <d-row>
              <d-col cols="12" md="6">
                <div class="form-group">
                  <label for="name"> Nazwa statusu: </label>

                  <validation-provider
                    rules="required"
                    name="name"
                    mode="lazy"
                    v-slot="{ errors }"
                  >
                    <d-input
                      :state="errors.length ? 'invalid' : null"
                      v-model="data.name"
                    />
                    <div class="invalid-feedback">
                      {{ errors[0] }}
                    </div>
                  </validation-provider>
                </div>
              </d-col>
              <br />
              <d-col cols="12" md="6">
                <div class="form-group color-picker-wrapper">
                  <label for="color"> Wybierz kolor statusu: </label>

                  <swatches-picker
                    v-model="data.color"
                    @mounted="onSwatchesMounted"
                    ref="swatches"
                  />
                </div>
              </d-col>
            </d-row>
          </validation-observer>

          <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
            Trwa ładowanie danych&hellip;
          </div>

          <d-alert v-if="loadError" show theme="warning">
            Wczytywanie danych nie powiodło się.
            <a href="javascript:window.location.reload();" class="alert-link"
              >Odśwież stronę</a
            >
            aby spróbować ponownie.
          </d-alert>
        </d-card-body>
      </d-card>
    </d-form>
  </d-container>
</template>

<style lang="scss" scoped>
// Color picker - pełna szerokość bez scrolla
.color-picker-wrapper {
  ::v-deep .vc-swatches {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    min-height: 400px !important;
    height: auto !important;
    box-shadow: none !important;
    padding: 0 !important;
    overflow: visible !important;
    border: none !important;
  }

  ::v-deep .vc-swatches-box {
    padding: 0 !important;
    overflow: visible !important;
    overflow-y: visible !important;
    overflow-x: visible !important;
    max-height: none !important;
    min-height: 400px !important;
    height: auto !important;
  }

  ::v-deep .vc-swatches-pick {
    overflow: visible !important;
    overflow-y: visible !important;
    max-height: none !important;
    min-height: 400px !important;
    height: auto !important;
  }
}
</style>

<style lang="scss">
/* Global styles for vue-color without scoped */
.vc-swatches,
.vc-swatches-picker {
  width: auto !important;
  max-width: auto !important;
  height: auto !important;
  max-height: none !important;
  box-shadow: none !important;
  webkit-box-shadow: none !important;
  padding: 0 !important;
  overflow: visible !important;
  overflow-y: visible !important;
  border: none !important;
}

.vc-swatches-box {
  padding: 0 !important;
  overflow: visible !important;
  overflow-y: visible !important;
  overflow-x: visible !important;
  max-height: none !important;
  height: auto !important;
}

.vc-swatches-pick {
  overflow: visible !important;
  overflow-y: visible !important;
  max-height: none !important;
  height: auto !important;
}
</style>

<script>
import FormUtils from "./../../utils/FormUtils.js";

export default {
  name: "status-form",
  computed: {
    allDataLoaded() {
      return this.loaded;
    },
    isEdit() {
      return !!this.$route.params.id;
    },
  },
  data() {
    return {
      data: {
        id: 0,
        name: "",
        color: "#ffffff",
      },
      loaded: false,
      loadError: false,
      submitted: false,
    };
  },
  mounted() {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    setPresetColors() {
      const swatches = this.$refs.swatches;
      if (!swatches || !swatches.palette) {
        return;
      }

      let colors = [...swatches.palette];
      const lastRow = colors[colors.length - 1];

      if (lastRow && lastRow.length === 2) {
        colors[colors.length - 1] = [...lastRow, "#fef2dd"];
        swatches.palette = colors;
      }
    },
    onSwatchesMounted() {
      this.$nextTick(() => {
        this.setPresetColors();
      });
    },
    loadItemData() {
      FormUtils.loadItemData(this, {
        endpointBase: "/system/statuses/item/",
        instanceFields: ["id", "name", "color"],
        loadedKey: "loaded",
        successAction: () => {
          if (!this.data.color) {
            this.data.color = "#ffffff";
          }
        },
      });
    },
    validateForm() {
      FormUtils.validate(this.$refs["status-form"], this.submitForm);
    },
    submitForm() {
      let endpointUrl = this.isEdit
        ? "/system/statuses/update/" + this.data.id
        : "/system/statuses/store";

      let formDataToSend = {
        name: this.data.name,
        color:
          typeof this.data.color === "object"
            ? this.data.color.hex
            : this.data.color,
      };

      this.submitted = true;
      
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: "Zapisano status",
        successText: "Wybrany status został zapisany",
        errorTitle: "Wystąpił błąd",
        errorText: "Zapis nie powiódł się. Spróbuj ponownie.",
        successAction: () => {
          this.$router.push("/admin/statuses");
        },
        failAction: () => {
          this.submitted = false;
        },
      });
    },
  },
};</script>
